/** @format */

export const DEFAULT_TEST_ID = 'holographic-background';
